/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ChangeSponsorService {
  private url: string = environment.host + '/participant';

  constructor(private http: HttpClient) {}

  public changeSponsor(payload: any, clientId: any, toClientId: any) {
    const url = `${this.url}/${clientId}/sponsorship/${toClientId}`;
    return this.http.put(url.toString(), payload).toPromise();
  }

  public changeOrganization(payload: any, clientId: any, orgUnitId: any) {
    const url = `${this.url}/${clientId}/organization/${orgUnitId}`;
    return this.http.put(url.toString(), payload).toPromise();
  }

  public changeParentOrganization(payload: any, clientId: any, NewParentOrgUnitID: any) {
    const url = `${this.url}/${clientId}/parentOrganization/${NewParentOrgUnitID}`;
    return this.http.put(url.toString(), payload).toPromise();
  }

  public changeOrgWithDownline(payload: any, clientId: any, toOrgId: any) {
    const url = `${this.url}/${clientId}/changeOrgWithDownline/${toOrgId}`;
    return this.http.put(url.toString(), payload).toPromise();
  }
}
